import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IntermediateClient from '../../../components/intermeditaryClient/index';
import CreateClient from '../../../components/createClient/index';
import CreateEmployee from '../../../components/createEmployee/index';
import BankDetails from '../../../components/bankDetails/index';
import ViewPayments from '../../../components/viewPayments/index';
import TotalItecEmp from '../../../components/totalItecEmp/index';

import Services from '../../../components/services/index';
import PendingInvoicesTiles from '../../../components/pendingInvoiceTiles';
import SupportCardTiles from '../../../components/supportCardTiles';
import ItecOpen from '../../../components/iTecOpen';
import ClientMasterCreation from '../../../components/clientMasterCreation/index';
// import Services from '../../../components/services/index';
import Invoices from '../../../components/invoices/index';
// import SupportCardTiles from '../../../components/supportCardTiles';
import PaymentHistory from '../../../components/paymentHistory';
import AdminPaymentHistory from '../../../components/adminPaymentHistory';
import useStyles from '../styles/index';
import { getIMCclientDetails } from '../../users/store/actions/index';
import { CommonConfig } from '../../../config/common-config';

function SuperAdminDashboard(props) {
    const classes = useStyles();
    const history = useHistory();
    const dispatch = useDispatch({});
    const [imcclients, SetImcclients] = useState([]);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    // const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    // console.log('userDetails', userDetails);
    // const clientFeature = userDetails.result && userDetails.result.data.features[4].subFeatures[0].isActive;
    // const bankFeature = userDetails.result && userDetails.result.data.features[1].subFeatures[2].isActive;
    // const imcViewFeature = userDetails.result && userDetails.result.data.features[2].subFeatures[0].isActive;
    // const itecViewFeature = userDetails.result && userDetails.result.data.features[0].subFeatures[1].isActive;
    // const adminViewPaymentFeature = userDetails.result && userDetails.result.data.features[7].subFeatures[1].isActive;
    // const openServiceViewFeature = userDetails.result && userDetails.result.data.features[5].subFeatures[1].isActive;
    // console.log('zzzzclientFeature', clientFeature);
    const axiosConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: bearerToken,
        },
    };

    // const imcclients = useSelector((state) => state.users.imcClients);
    let imcvalues = [];
    imcclients &&
        imcclients.content &&
        imcclients.content.length &&
        imcclients.content.map((datadbname, i) => {
            if (datadbname.dbName !== 'itec') {
                imcvalues.push(datadbname);
            }
        });

    useEffect(() => {
        history.push({
            state: { breadCrumbLabel: props.breadCrumbLabel, breadCrumbPath: props.breadCrumbPath },
        });
        // dispatch(getIMCclientDetails());
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/s-int-clients`, axiosConfig)
            .then((response) => {
                SetImcclients(response.data);
            })
            .catch((error) => {
                //console.log(error);
            });
    }, []);

    return (
        <div className={classes.dashboardmaindiv}>
            <Grid container spacing={3}>
                <Grid item sm={6} xs={12}>
                    <IntermediateClient />
                </Grid>
                <Grid item sm={6} xs={12}>
                    <TotalItecEmp />
                </Grid>
                <Grid item sm={12} xs={12}>
                    <div className={classes.imcTable}>
                        <div className={classes.imcHeading}>
                            <h2>Intermediary Clients </h2>
                        </div>
                        <TableContainer component={Paper} className={classes.tablemaincontainer}>
                            <Table className={classes.table} stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.imctableheading}>Name of the entity</TableCell>
                                        <TableCell className={classes.imctableheading} align="left">
                                            GSTIN
                                        </TableCell>
                                        <TableCell className={classes.imctableheading} align="left">
                                            Admin email id
                                        </TableCell>
                                        <TableCell className={classes.imctableheading} align="left">
                                            Domain name
                                        </TableCell>
                                        <TableCell className={classes.imctableheading} align="left">
                                            Admin mobile number
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {imcvalues &&
                                        imcvalues.map((row, index) => (
                                            <TableRow key={Math.random()}>
                                                <TableCell className={classes.imctableBody} component="th" scope="row">
                                                    {row.intClientName}
                                                </TableCell>
                                                <TableCell className={classes.imctableBody} align="left">
                                                    {row.gstIn}
                                                </TableCell>
                                                <TableCell className={classes.imctableBody} align="left">
                                                    {row.adminEmail}
                                                </TableCell>
                                                <TableCell className={classes.imctableBody} align="left">
                                                    {row.dbName}
                                                </TableCell>
                                                <TableCell className={classes.imctableBody} align="left">
                                                    {row.adminMobile}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </Grid>
                <Grid item sm={3} xs={12}>
                    <CreateClient />
                </Grid>
                <Grid item sm={3} xs={12}>
                    <CreateEmployee />
                </Grid>
                <Grid item sm={3} xs={12}>
                    <BankDetails />
                </Grid>
                <Grid item sm={3} xs={12}>
                    <ViewPayments />
                </Grid>
                {/* <Grid container spacing={3}> */}
                {/* {imcViewFeature === true ? (
                    <Grid item sm={3} xs={6}>
                        <CreateClient />
                    </Grid>
                ) : null}
                {itecViewFeature === true ? (
                    <Grid item sm={3} xs={6}>
                        <CreateEmployee />
                    </Grid>
                ) : null}
                {bankFeature === true ? (
                    <Grid item sm={3} xs={6}>
                        <BankDetails />
                    </Grid>
                ) : null}
                {adminViewPaymentFeature === true ? (
                    <Grid item sm={3} xs={6}>
                        <ViewPayments />
                    </Grid>
                ) : null}
                {openServiceViewFeature === true ? (
                    <Grid item sm={3} xs={6}>
                        <Services />
                    </Grid>
                ) : null}
                {clientFeature === 'true' ? (
                    <Grid item sm={3} xs={6}>
                        <Invoices />
                    </Grid>
                ) : null}
                {clientFeature === 'true' ? (
                    <Grid item sm={3} xs={6}>
                        <PendingInvoicesTiles />
                    </Grid>
                ) : null}
                {clientFeature === 'true' ? (
                    <Grid item sm={3} xs={6}>
                        <SupportCardTiles />
                    </Grid>
                ) : null}
                {clientFeature === 'true' ? (
                    <Grid item sm={3} xs={6}>
                        <ItecOpen />
                    </Grid>
                ) : null}
                {clientFeature === 'true' ? (
                    <Grid item sm={3} xs={6}>
                        <ClientMasterCreation />
                    </Grid>
                ) : null}
                {clientFeature === 'true' ? (
                    <Grid item sm={3} xs={6}>
                        <PaymentHistory />
                    </Grid>
                ) : null}
                {clientFeature === 'true' ? (
                    <Grid item sm={3} xs={6}>
                        <AdminPaymentHistory />
                    </Grid>
                ) : null} */}
                {/* </Grid> */}
            </Grid>
        </div>
    );
}

export default SuperAdminDashboard;
